"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var semantic_ui_react_1 = require("semantic-ui-react");
var react_intersection_observer_1 = require("react-intersection-observer");
var index_module_scss_1 = __importDefault(require("./index.module.scss"));
var react_1 = require("react");
var axios_1 = __importDefault(require("axios"));
var Truncate_1 = require("../../components/Truncate");
var i18next_1 = require("i18next");
function CollectionsSection() {
    var _a = (0, react_1.useState)([]), creators = _a[0], setCreators = _a[1];
    var _b = (0, react_1.useState)(false), loading = _b[0], setLoading = _b[1];
    var _c = (0, react_intersection_observer_1.useInView)({
        rootMargin: "0px 0px",
    }), ref = _c.ref, inView = _c.inView;
    (0, react_1.useEffect)(function () {
        function fetchData() {
            return __awaiter(this, void 0, void 0, function () {
                var response, data, err_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 3, , 4]);
                            return [4 /*yield*/, axios_1.default.get("".concat(process.env.REACT_APP_MIDDLEWARE, "fans/creators"))];
                        case 1:
                            response = _a.sent();
                            return [4 /*yield*/, response.data];
                        case 2:
                            data = _a.sent();
                            setCreators(data);
                            setLoading(true);
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            // Handle any errors
                            setLoading(true);
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
        if (!loading) {
            fetchData();
        }
    }, [!creators, loading]);
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: index_module_scss_1.default.benefits }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: index_module_scss_1.default.container, ref: ref, style: inView
                    ? {
                        transform: "scale(1)",
                        filter: "grayscale(0)",
                        transition: "ease-in-out 0.5s",
                    }
                    : {
                        transform: "scale(0.8)",
                        filter: "grayscale(1)",
                        opacity: "0.5",
                        transition: "ease-in-out 0.8s",
                    } }, { children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid, __assign({ columns: "one", divided: true }, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Row, __assign({ className: index_module_scss_1.default.row }, { children: (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Grid.Column, __assign({ className: index_module_scss_1.default.column }, { children: [(0, jsx_runtime_1.jsx)("h3", { children: "VIP Clubs" }), (0, jsx_runtime_1.jsx)("p", __assign({ className: index_module_scss_1.default.subHeading }, { children: (0, i18next_1.t)("fanClubHeading") }))] })) })) })), creators.length > 0 ? ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid, __assign({ columns: "four", divided: true }, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Row, __assign({ className: index_module_scss_1.default.row }, { children: creators === null || creators === void 0 ? void 0 : creators.map(function (creator, index) {
                                var _a;
                                return ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Column, __assign({ className: index_module_scss_1.default.column }, { children: (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Card, __assign({ className: index_module_scss_1.default.benefit, href: "/creator/".concat(creator === null || creator === void 0 ? void 0 : creator.username), disabled: true }, { children: [(0, jsx_runtime_1.jsx)("img", { src: process.env.REACT_APP_DIRECTUS_BACKEND_ASSETS +
                                                    ((_a = creator === null || creator === void 0 ? void 0 : creator.avatar) === null || _a === void 0 ? void 0 : _a.id) }), (0, jsx_runtime_1.jsx)("div", { className: index_module_scss_1.default.overlay }), (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Card.Content, __assign({ className: index_module_scss_1.default.content }, { children: [(creator === null || creator === void 0 ? void 0 : creator.creator_type) != "None" && ((0, jsx_runtime_1.jsx)("div", __assign({ className: index_module_scss_1.default.creator_type }, { children: (0, jsx_runtime_1.jsx)("span", { children: creator === null || creator === void 0 ? void 0 : creator.creator_type }) }))), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Card.Header, __assign({ className: creator.disabled && index_module_scss_1.default.disabled }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: index_module_scss_1.default.benefits_details }, { children: (0, jsx_runtime_1.jsxs)("p", __assign({ className: index_module_scss_1.default.details }, { children: [creator === null || creator === void 0 ? void 0 : creator.first_name, (0, jsx_runtime_1.jsx)("p", __assign({ className: index_module_scss_1.default.content }, { children: (0, Truncate_1.truncate)(creator === null || creator === void 0 ? void 0 : creator.description, 100) })), (0, jsx_runtime_1.jsx)("br", {})] })) })) }))] }))] })) }), index));
                            }) })) }))) : ((0, jsx_runtime_1.jsx)("div", { className: "loader" }))] })) })) }));
}
exports.default = CollectionsSection;
